module.exports = __webpack_public_path__ + "img/apply_m.e34c01f9.png";